var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVehicleMarkerCalloutYay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 250,
    height: 250,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "aVzrFXuu",
    d: "m189.49,158.99l-0.19,0.29l-0.25,0.35l-0.27,0.34l-0.28,0.33l-0.29,0.32l-0.3,0.31l-0.32,0.3l-0.34,0.29l-0.34,0.27l-0.36,0.27l-0.37,0.25l-0.38,0.23l-0.4,0.22l-0.41,0.21l-107.24,51.92l-0.42,0.19l-0.42,0.17l-0.42,0.16l-0.43,0.13l-0.43,0.12l-0.43,0.1l-0.43,0.08l-0.43,0.07l-0.43,0.05l-0.43,0.03l-0.44,0.01l-0.43,0l-0.43,-0.02l-0.42,-0.04l-0.43,-0.05l-0.42,-0.07l-0.42,-0.09l-0.41,-0.1l-0.41,-0.12l-0.41,-0.13l-0.4,-0.15l-0.39,-0.16l-0.39,-0.18l-0.38,-0.19l-0.37,-0.21l-0.37,-0.22l-0.36,-0.24l-0.35,-0.25l-0.34,-0.26l-0.33,-0.28l-0.32,-0.29l-0.31,-0.31l-0.3,-0.32l-0.28,-0.33l-0.28,-0.34l-0.26,-0.36l-0.25,-0.37l-0.24,-0.39l-0.22,-0.39l-0.21,-0.41l-30.06,-62.1l-0.19,-0.41l-0.17,-0.42l-0.15,-0.43l-0.14,-0.42l-0.12,-0.43l-0.1,-0.43l-0.08,-0.43l-0.07,-0.43l-0.04,-0.44l-0.03,-0.43l-0.02,-0.43l0.01,-0.43l0.02,-0.43l0.03,-0.43l0.06,-0.42l0.06,-0.42l0.09,-0.42l0.1,-0.42l0.12,-0.41l0.13,-0.4l0.15,-0.4l0.16,-0.4l0.18,-0.38l0.19,-0.38l0.21,-0.38l0.22,-0.36l0.24,-0.36l0.25,-0.35l0.26,-0.34l0.28,-0.33l0.29,-0.32l0.31,-0.31l0.32,-0.3l0.33,-0.29l0.34,-0.27l0.36,-0.26l0.37,-0.25l0.39,-0.24l0.39,-0.22l0.41,-0.21l107.25,-51.92l0.41,-0.19l0.42,-0.17l0.42,-0.15l0.43,-0.14l0.43,-0.12l0.43,-0.1l0.43,-0.08l0.43,-0.07l0.43,-0.04l0.44,-0.03l0.43,-0.02l0.43,0.01l0.43,0.02l0.35,0.03l-0.71,-1.47l39.64,5.72l39.63,5.73l-20.09,34.64l-20.1,34.63l0,0l-0.05,-0.09z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "c1hD68tUIN",
    d: "m91.28,65.48l50.31,-41.36l-50.31,147.88l-52.45,-147.88l52.45,41.36z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "b1ib59dXkx",
    d: "m174.96,117.56c0.61,4.32 -2.4,8.33 -6.73,8.94c-4.32,0.61 -8.33,-2.41 -8.94,-6.73c-0.6,-4.33 2.41,-8.33 6.74,-8.94c4.32,-0.61 8.33,2.41 8.93,6.73z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "background"), /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    id: "canvas_background",
    height: 252,
    width: 252,
    y: -1,
    x: -1
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "Layer 1"), /*#__PURE__*/React.createElement("g", {
    id: "svg_1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svg_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svg_3"
  }, /*#__PURE__*/React.createElement("use", {
    id: "svg_4",
    fill: "#b1b1b1",
    xlinkHref: "#aVzrFXuu"
  }), /*#__PURE__*/React.createElement("g", {
    id: "svg_5"
  }, /*#__PURE__*/React.createElement("use", {
    id: "svg_6",
    stroke: "#b1b1b1",
    fillOpacity: 0,
    xlinkHref: "#aVzrFXuu"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "svg_7"
  }, /*#__PURE__*/React.createElement("use", {
    id: "svg_8",
    fill: "#808080",
    xlinkHref: "#c1hD68tUIN"
  }), /*#__PURE__*/React.createElement("g", {
    id: "svg_9"
  }, /*#__PURE__*/React.createElement("use", {
    id: "svg_10",
    stroke: "#b1b1b1",
    fillOpacity: 0,
    xlinkHref: "#c1hD68tUIN"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "svg_11"
  }, /*#__PURE__*/React.createElement("use", {
    id: "svg_12",
    fill: "#ffffff",
    xlinkHref: "#b1ib59dXkx"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVehicleMarkerCalloutYay);
export default __webpack_public_path__ + "static/media/vehicleMarkerCallout_Yay.dbdb1dde8d469edcd06ee620b9e03e20.svg";
export { ForwardRef as ReactComponent };